import React, { useState, useEffect, useReducer, createContext, useContext } from 'react';
import { Input, Button, Upload, Select, message, Modal, Spin, DatePicker } from 'antd';
import Relationship from './RelationShip';
import ModifyToolModal from './ModifyToolModal';
import RelationTable from './RelationTable';
import SelectNode from '../../../component/SelectNode';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { getToday } from '../../../util/inspiration';
import { fetchSearchNode, addNode, addNewNodeRelation, uploadNodeTagExcel, fetchNodeImgCount, fetchPendCheckNodeImgCount } from '../../../api/inspiration';
import './index.less';

const { Option } = Select;
const Ctx = createContext();

const reducer = (state, action) => {
    return {...state, ...action};
}

const relationTypes = [
    '上级节点',
    '下级节点',
    '正向灵感',
    '反向灵感',
    '正向配件',
    '反向配件',
];

const AddNodeModal = props => {
    const { visible, setVisible } = props;
    const { state, dispatch } = useContext(Ctx);
    const [nodeName, setNodeName] = useState("");
    const [superiorNode, setSuperiorNode] = useState(null);

    useEffect(() => {
        if (!visible) {
            setNodeName("");
        }
    }, [visible]);

    const handleAddNodeModalOk = async () => {
        if (nodeName.trim() && superiorNode) {
            const res = await addNode({
                "newNodeTagName": nodeName,
                "relationTagId": superiorNode.id,
                "relationTagName": superiorNode.word,
                "relationType": 1, // 1上级节点 2下级节点 3正向灵感 4反向灵感 5正向配件 6反向配件
                "tagType": superiorNode.type // 0属性标签 1实体标签
            });

            if (res?.error?.code == 0) {
                message.success("添加成功");
                dispatch({update: nodeName});
                setVisible(false);
            } else if (res?.error?.message) {
                message.error(res?.error?.message);
            } else {
                message.error("添加失败");
            }
        } else if (!nodeName.trim()) {
            message.error("请输入节点名称");
        } else {
            message.error("请选择上级节点");
        }
        
    };

    const handleAddNodeModalCancel = () => {
        setVisible(false);
    };

    return (
        <Modal visible={visible} wrapClassName='addNode_modal' onOk={handleAddNodeModalOk} onCancel={handleAddNodeModalCancel} footer={[
            <Button key="back" type="primary" onClick={handleAddNodeModalCancel}>
            取消
            </Button>,
            <Button key="submit" type="primary" onClick={handleAddNodeModalOk}>
            完成
            </Button>
        ]}>
            <h3>新增节点</h3>
            <Input placeholder='请输入节点名称' value={nodeName} onChange={e => setNodeName(e.target.value)} />
            <h3 style={{marginTop: '10px'}}>请选择上级节点</h3>

            <SelectNode setNode={setSuperiorNode} node={superiorNode} />
        </Modal>
    )
};

const AddRelation = props => {
    const { visible, setVisible, relationType, nodeInfo } = props;
    const { state, dispatch } = useContext(Ctx);
    const [superiorNode, setSuperiorNode] = useState(null);

    useEffect(() => {
        if (visible) setSuperiorNode(null);
    }, [visible]);

    const handleOk = async () => {
        if (superiorNode) {
            const res = await addNewNodeRelation({
                "secondNodeTagId": nodeInfo.centerNodeTag.id,
                "firstNodeTagId": superiorNode.id,
                "relationType": relationType, // 1上级节点 2下级节点 3正向灵感 4反向灵感 5正向配件 6反向配件
                "tagType": superiorNode.type // 0属性标签 1实体标签
            });

            if (res?.error?.code == 0) {
                message.success("添加成功");
                dispatch({updateRelations: true});
                setVisible(false);
            } else if (res?.error?.message) {
                message.error(res?.error?.message);
            } else {
                message.error("添加失败");
            }
        } else if (!superiorNode) {
            message.error(`请选择已有节点`);
        }
        
    };

    const handleCancel = () => {
        setVisible(false);
    };

    return (
        <Modal visible={visible} wrapClassName='addNode_modal' onOk={handleOk} onCancel={handleCancel} footer={[
            <Button key="back" type="primary" onClick={handleCancel}>
            取消
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
            完成
            </Button>
        ]}>
            <h3>新增{relationTypes[relationType - 1]}</h3>
            <SelectNode setNode={setSuperiorNode} nodeTagType={nodeInfo.centerNodeTag.type} node={superiorNode} />
        </Modal>
    )
};

export default () => {
    const today = getToday();
    const [addNodeModalVisible, setAddNodeModalVisible] = useState(false);
    const [nodeInfo, setNodeInfo] = useState(null);
    const [relationType, setRelationType] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isEditRelation, setEditRelation] = useState(false);
    const [addRelationModalVisible, setAddRelationModalVisible] = useState(false);
    const [superiorNode, setSuperiorNode] = useState(null);
    const [putStartDate, setPutStartDate] = useState(today);
    const [putEndDate, setPutEndDate] = useState(today);
    const [pendCheckputEndDate, setPendCheckPutEndDate] = useState(today);
    const [pendCheckputStartDate, setPendCheckPutStartDate] = useState(today);
    const [nodeImgCount, setNodeImgCount] = useState(null); // 节点实时数据
    const [pendCheckNodeImgCount, setPendCheckNodeImgCount] = useState(null); // 节点待验证实时数据
    const [isModifyUpdateModalVisible, setModifyUpdateModalVisible] = useState(false);
    const [toolInfo, setToolInfo] = useState(null);
    const [ state, dispatch ] = useReducer(reducer, { update: '', updateRelations: false});

    useEffect(() => {
        if (state.update) {
            setSuperiorNode({word: state.update});
        }
    }, [state.update]);

    useEffect(() => {
        if (superiorNode?.word) {
            setNodeInfo(null);
            getSearchNode(superiorNode?.word);
        }        
    }, [superiorNode]);

    useEffect(() => {
        if (state.updateRelations) {
            getSearchNode(superiorNode?.word);
        }
    }, [state.updateRelations]);

    useEffect(() => {
        if (nodeInfo?.centerNodeTag?.word) {
            getNodeImgCount(putStartDate, putEndDate);
            getPendCheckNodeImgCount(pendCheckputStartDate, pendCheckputEndDate);
        }
    }, [nodeInfo]);

    const getSearchNode = async word => {
        setLoading(true);
        const res = await fetchSearchNode(word);
        if (res?.error?.code == 0 && res.data) {
            setNodeInfo(res.data);
        } else if (res?.error?.message) {
            message.error(res.error.message);
        } else {
            message.error("网络连接失败");
        }
        setLoading(false);
    };

    const openAddNodeModal = () => {
        dispatch({update: ''});
        setAddNodeModalVisible(true);
    };

    // 上传excel回调
    const uploadExcel = info => {
        if (info.file.status === 'done') {
            const res = info.file.response;
            if (res?.error?.code == 0) {
                message.success('上传成功');
                if (res.data)
                window.location.href = res.data;
            } else if (res?.error?.message) {
                message.error(res.error.message);
            } else {
                message.error("上传失败");
            }
        } else if (info.file.status === 'error') {
            message.error('上传失败');
        }
    };

    const onTypeChange = v => {
        setRelationType(v);
    };

    const editRelation = () => {
        setEditRelation(!isEditRelation);
    };

    const openAddRelationModal = () => {
        dispatch({updateRelations: false});
        setAddRelationModalVisible(true);
    };

    const changePutDate = value => {
        setPutStartDate(value[0].format('YYYY-MM-DD'));
        setPutEndDate(value[1].format('YYYY-MM-DD'));
        getNodeImgCount(value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD'));
    };

    const changePendCheckPutDate = value => {
        setPendCheckPutStartDate(value[0].format('YYYY-MM-DD'));
        setPendCheckPutEndDate(value[1].format('YYYY-MM-DD'));
        getPendCheckNodeImgCount(value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD'));
    };

    const getNodeImgCount = async (putStartDate, putEndDate) => {
        const res = await fetchNodeImgCount(nodeInfo.centerNodeTag.word, putStartDate, putEndDate);
        if (res?.error?.code == 0 && res.data) {
            setNodeImgCount(res.data);
        } else {
            setNodeImgCount(null);
        }
    };

    const getPendCheckNodeImgCount = async (putStartDate, putEndDate) => {
        const res = await fetchPendCheckNodeImgCount(nodeInfo.centerNodeTag.word, putStartDate, putEndDate);
        if (res?.error?.code == 0 && res.data) {
            setPendCheckNodeImgCount(res.data);
        } else {
            setPendCheckNodeImgCount(null);
        }
    };

    const openModifyUpdateModal = () => {
        setModifyUpdateModalVisible(true);
    };

    return (
        <div className='nodeManage_wrap'>
            <h1 className='main_title'>节点管理</h1>
            <div className='toolbar'>
                <SelectNode setNode={setSuperiorNode} node={superiorNode} />
                <Button onClick={openAddNodeModal}>新增</Button>
                <Upload onChange={uploadExcel} action={uploadNodeTagExcel()} accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'>
                    <Button type="link">批量导入新增</Button>
                </Upload>
            </div>
            
            {
                nodeInfo && !loading ? (
                    <>
                        <h1>一、节点概况：{nodeInfo.centerNodeTag?.word ?? ""}</h1>
                        <Relationship nodeInfo={nodeInfo} setRelationType={setRelationType} />
                        <div className='nodeManage_relation_detail_header'>
                            <h1>二、节点关系明细：</h1>
                            <Select value={relationType} style={{ width: 180 }} onChange={onTypeChange}>
                                {
                                    relationTypes.map((v, i) => <Option key={i} value={i + 1}>{v}</Option>)
                                }
                            </Select>
                            <Button onClick={editRelation}>{isEditRelation ? '取消' : '编辑' }</Button>
                            <Button onClick={openAddRelationModal}>新增</Button>
                        </div>
                        <RelationTable isEditRelation={isEditRelation} relationType={relationType} nodeInfo={nodeInfo} setEditRelation={setEditRelation} word={superiorNode?.word} getSearchNode={getSearchNode} />

                        <h1>三、节点实时数据</h1>
                        <div className='nodeManage_data_container'>
                            <table border="1" width="50%">
                                <thead width="100%" className='thead'>
                                    <tr width="100%">
                                        <td>图片数量</td>
                                        <td>「待验证」图片数量</td>
                                    </tr>
                                </thead>
                                
                                <tbody width="100%">
                                    <tr width="100%">
                                        <td>{nodeImgCount?.imgCount || 0}</td>
                                        <td>{nodeImgCount?.pendCheckImgCount || 0}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h2>
                                库存图片效率统计
                            </h2>
                            <DatePicker.RangePicker onChange={changePutDate} locale={locale} value={[moment(putStartDate), moment(putEndDate)]} allowClear={false} />
                            <table className='statistics_table' border="1" width="100%" align="center">
                                <thead width="100%" className='thead'>
                                    <tr width="100%">
                                        <td>被召回总次数</td>
                                        <td>被转化总次数</td>
                                        <td>转化次数去重</td>
                                        <td>召回转化率</td>
                                        <td>单次召回转化次数</td>
                                        <td>所有节点召回总次数</td>
                                        <td>节点召回比例</td>
                                    </tr>
                                </thead>
                                
                                <tbody width="100%">
                                    <tr width="100%">
                                        <td>{nodeImgCount?.nodeCallbackCount || 0}</td>
                                        <td>{nodeImgCount?.nodeTransCount || 0}</td>
                                        <td>{nodeImgCount?.nodeNoDuplicateTransCount || 0}</td>
                                        <td>{nodeImgCount?.nodeNoDupTransRate || 0}</td>
                                        <td>{nodeImgCount?.nodeTransRate || 0}</td>
                                        <td>{nodeImgCount?.allNodeCallBackCount || 0}</td>
                                        <td>{nodeImgCount?.nodeCallbackRate || 0}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h2>
                                「待验证」图片转化效率统计
                            </h2>
                            <DatePicker.RangePicker onChange={changePendCheckPutDate} locale={locale} value={[moment(pendCheckputStartDate), moment(pendCheckputEndDate)]} allowClear={false} />
                            <table className='statistics_table' border="1" width="100%" align="center">
                                <thead width="100%" className='thead'>
                                    <tr width="100%">
                                        <td>曝光张数</td>
                                        <td>曝光次数</td>
                                        <td>转化张数</td>
                                        <td>转化率</td>
                                        <td>转化效率</td>
                                    </tr>
                                </thead>
                                
                                <tbody width="100%">
                                    <tr width="100%">
                                        <td>{pendCheckNodeImgCount?.pendCheckExposureImgCount || 0}</td>
                                        <td>{pendCheckNodeImgCount?.pendCheckExposureTimes || 0}</td>
                                        <td>{pendCheckNodeImgCount?.pendCheckTransImgCount || 0}</td>
                                        <td>{pendCheckNodeImgCount?.pendCheckTransRate || 0}</td>
                                        <td>{pendCheckNodeImgCount?.pendCheckTransEfficiency || 0}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h1>四、节点更新</h1>
                        <div className='nodeManage_update_header'>
                            来源：{toolInfo?.crawlToolName ?? '暂无'}；
                            <span onClick={openModifyUpdateModal}>{toolInfo?.currentCrawlToolStatus==0||toolInfo?.paramChange?'爬取策略未生效，请修改策略':'修改更新策略'}</span>
                            {
                                toolInfo?.crawlToolParams?.map((v, i) => <div key={i}>{v.paramDesc}：{v.paramValue ?? '未填写'}</div>)
                            }
                        </div>
                        <ModifyToolModal superiorNode={superiorNode} isModifyUpdateModalVisible={isModifyUpdateModalVisible} setModifyUpdateModalVisible={setModifyUpdateModalVisible} setToolInfo={setToolInfo} toolInfo={toolInfo} nodeInfo={nodeInfo}/>

                        <Ctx.Provider value={{state, dispatch}} >
                            <AddRelation visible={addRelationModalVisible} setVisible={setAddRelationModalVisible} relationType={relationType} nodeInfo={nodeInfo}/>
                        </Ctx.Provider>
                    </>
                ) : (
                    <Spin spinning={loading}>
                        <div style={{height: '60px'}}></div>
                    </Spin>
                )
            }

            <Ctx.Provider value={{state, dispatch}} >
                <AddNodeModal visible={addNodeModalVisible} setVisible={setAddNodeModalVisible}/>
            </Ctx.Provider>
        </div>
    )
}